<template>
  <div class="news">
        <div class="news-left wow animate__animated animate__fadeInLeft" @click="News">
            <div class="news-left-img">
                <img src="./img/tu8.jpg">
                <div class="news-left-text">
                    Enterprise Introduction
                </div>
            </div>
            <div class="news-left-nr"> 
                <p>Welcome to visit the website of Jilin Medical Design Institute Co., Ltd!</p>
                <div>Jilin Medical Design Institute Co., Ltd. (hereinafter referred to as Jilin Medical Design Institute) was founded in 1986 as a private enterprise, vice president unit of China Medical Engineering Design Association, and AAA credit enterprise in the survey and design industry of Jilin Province......
                    <span>ALL ></span>
                </div>
            </div>
        </div>
        <div class="news-left wow animate__animated animate__fadeInLeft news-leftld"  @click="Addls">
            <div class="news-left-img">
                <img src="./img/tu9.jpg">
                <div class="news-left-text">
                    PRESIDENT SPEECH
                </div>
            </div>
            <div class="news-left-nr">
                    <p>Welcome to visit the website of Jilin Medical Design Institute Co., Ltd!</p>
                    <div>Jilin Medical Design Institute Co., Ltd. is a vice president unit of the China Medical Engineering Design Association, with a Class A design qualification approved by the Ministry of Housing and Urban Rural Development in the chemical, petrochemical, and pharmaceutical industries,......
                        <span>ALL ></span>
                    </div>
                    <!-- <p class="news-left-time">
                        <img src="./img/xt_2.png" class="xt-2">
                        <i>2018-11-22</i>
                    </p> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            lnt:0,
            nametab:[
                {id:1,name:'新闻中心'},
                {id:4,name:'行业动态'},
                {id:5,name:'法律法规'}
            ]
        }
    },
    props:['Newsname','NewsNav'],
    methods: {
        Addls(){
            this.$router.push({name:'EnglishNews'})
        },
        News(){
            this.$router.push({name:'EnglishContact'})
        },
        lieb(index){
            this.lnt=index
            this.$emit('Newslieb',this.nametab[index].id)
        },
        NewsJump(){
            let url=this.NewsNav[this.lnt+1].url
            this.$router.push({
                name:url,
            })
        }
    },
}
</script>

<style scoped>
    a:hover{
        text-decoration:none;
    }
    .news {
        width: 100%;
        margin: 0 auto;
        padding: 10px;
        overflow: hidden;
        margin-top: 60px;
    }

    .news-left {
        float: left;
        width: 48%;
        height: 720px;
        box-shadow: 0px 0px 5px #d9d9d9;
        overflow: hidden;
        cursor: pointer;
    }
    .news-left:nth-child(2){
        float: right;
    }
    .news-leftld{
        margin-left: 30px;
    }
    .news-left-img {
        position: relative;
    }

    .news-left-img img {
        width: 100%;
    }

    .liedqn {
        position: absolute;
        top: 300px;
        right: 16px;
        font-size: 18px;
        color: #3dabed;
    }
    .news-tab-bj{
        background-color: #f6f6f6;;
    }
    .news-tab{
        width: 100%;
        height: 50px;
        background-color: #fff;
    }
    .news-tab li{
        float: left;
        width: 33.3%;
        background-color: #fff;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        cursor: pointer;
    }
    .news-tab .news-tab-click{
        background-color: #0082e4; /* 针对不支持渐变的浏览器 */
        background-image: linear-gradient(to right, #008df1 , #0d1f61);
        color: #fff;
    }
    .news-left-text {
        padding: 0 24px;
        height: 58px;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 58px;
        background-color: #000;
        /* 不支持线性的时候显示 */
        background-image: linear-gradient(to right, #0385fb, #09014f);
        font-size: 20px;
        z-index: 1;
    }

    .news-left-nr {
        width: 88%;
        margin: 0 auto;
        margin-top: 23px;
    }

    .news-left-nr p {
        font-size: 20px;
        font-weight: bold;
    }

    .news-left-nr div {
        font-size: 16px;
        color: #666;
        width: 100%;
        text-align: justify;
        margin-top: 24px;
        text-indent: 2em;
        line-height: 28px;
    }

    .news-left-nr div span {
        color: #0086d1;
    }

    .news-folird {
        float: right;
        position: relative;
    }

    .news-left-ul {
        position: relative;
        width: 1620px;
    }

    .news-left-ul li {
        float: left;
        width: 540px;
        overflow: hidden;
        position: relative;
    }
    .news-left-time img {
        width: 16px;
        height: 16px;
        float: left;
    }
    .news-content a{
    width: 90%;
    padding: 18px 5% 18px 5%;
    display: block;
    }
    .news-content i{
        font-size: 16px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp:1;
        -webkit-box-orient: vertical;
        color: #333;
    }
    .news-content div{
        margin-top: 8px;
        overflow: hidden;
        padding-left: 2%;
    }
    .news-content:hover{
        background-color: #fff;
    }
    .news-content:hover i{
        background-color: #fff;
        background-image: linear-gradient(to right, #0083f1, #120f3e); /* 线性渐变背景，方向向上 */
        -webkit-background-clip: text; /* 背景被裁剪成文字的前景色 */
        -webkit-text-fill-color: transparent; /* 文字填充颜色变透明 */   

    }
    .news-content .xt-2 {
        float: left;
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }
    .news-more {
        width: 100%;
        height: 50px;
        line-height: 45px;
        color: #0081f0;
        text-align: center;
        font-size: 14px;
    }
    .news-left-time img {
        width: 16px;
        height: 16px;
        float: left;
    }
    .news-left-time i {
        font-size: 12px;
        font-weight: normal;
        float: left;
        margin-left: 4px;
        color: #999;
    }
    .news-left-time {
        float: right;
    }
    @media (max-width: 768px){
        .news-left-nr p{
            font-size: 18px;
        }
        .news{
            padding: 0px;
            margin-top: 16px;
        }
        .news-left-img img{
            height: auto;
        }
        .news-left{
            width: 100%;
            margin: 0 auto;
            height: auto;
            padding-bottom: 12px;
            margin-bottom: 24px;
            float: none;
        }
        .news-left-text{
            width: 160px;
            height: 48px;
            line-height: 48px;
            font-size: 14px;
        }
        .news-left-nr div{
            margin-top: 8px;
        }
        .news-content a{
            padding: 10 px 5% 10px 5%;
        }
    }
</style>